import { MatTableDataSource } from '@angular/material/table';
import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { AngularFireStorage } from '@angular/fire/storage';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/shared/services/auth.service';
import { map, finalize } from 'rxjs/operators';
import { Router } from '@angular/router';
import { RouteService } from 'src/app/shared/services/route.service';

export interface empresa {
  cantCursos: number;
  cantInstructores: number;
  cantVentas: number;
  fechaCreacion: any;
  id: string;
  nombre: string;
  publicado: boolean;
}

@Component({
  selector: 'lista-empresas',
  templateUrl: './lista-empresas.component.html',
  styleUrls: ['./lista-empresas.component.css']
})
export class ListaEmpresasComponent {

  constructor(
    public authService: AuthService,
    public afAuth: AngularFireAuth,
    private afs: AngularFirestore,
    private storage: AngularFireStorage,
    private router: Router,
    public routeService: RouteService,
  ) { }

  array: empresa[] = [];

  ngOnInit() {

    this.afs.doc("global/indiceEmpresas").get().subscribe(snap => {
      const empresas = snap.data();
      let arr = []
      Object.keys(empresas).map(function (key) {
        arr.push(empresas[key])
        return arr;
      });
      const length = arr.length
      let arreglo = []
      for (let index = 0; index < length; index++) {
        const empresa: empresa = {
          cantCursos: arr[index].cantCursos,
          cantInstructores: arr[index].cantInstructores,
          cantVentas: arr[index].cantVentas,
          fechaCreacion: arr[index].fechaCreacion,
          id: arr[index].id,
          nombre: arr[index].nombre,
          publicado: arr[index].publicado,
        }
        arreglo.push(empresa)
      }
      this.array = arreglo
      this.array.sort((a, b) => a.nombre.localeCompare(b.nombre));
      console.log(arreglo)
    })
  }

}